import { createApp } from 'vue'
import App from './App.vue'
//导入elementPlus
import ElementPlus from 'element-plus'
import axios from 'axios'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'


//icon
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import router from "./router";
import store from './store'
import VFormRender from 'vform3-builds/dist/render.umd.js'  //引入VFormRender组件
import 'vform3-builds/dist/designer.style.css'  //引入VForm3样式
import "@/assets/style/common.css";
import scui from './scui'
const app = createApp(App);

app.use(store);
app.use(router);
app.use(ElementPlus, {
  locale: zhCn,
})
// app.use(i18n);
app.use(scui);
app.use(VFormRender)  //全局注册VFormRender等组件

window.axios = axios

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
//挂载app
app.mount('#app');
